<template>
  <div class="pvip-container">
    <navigation
      :customClickEvent="true"
      @click="detention"
      arrTheme='grey'
      :theme="{
        background: '#1C2032',
        color: '#fff'
      }"
    >
      <span>小美VIP会员</span>
      <span
        slot="right"
        class="rule-txt"
        :class="!showPoint&&'point'"
        @click="jumpRule"
      > 规则说明</span>
    </navigation>
    <div class="section-vip">
      <notice
        class="notice"
        v-if="!isVip"
        them='deep-dark'
      />
      <!-- vip -->
      <div class="vip-card-container" @click="jumpVIP('/vip/lvip')">
        <div class="type-item">
          <div class="vip-type">小美VIP·轻享版</div>
          <nd-button class="more-button">更多特权</nd-button>
        </div>
        <p class="exp">每日仅{{vipDetail.dayOfPay}}元，享超{{vipDetail.equityCount}}项权益，最高省{{vipDetail.saveAmt}}元</p>
        <div class="items-contaienr">
          <div
            class="item"
            v-for="(item,index) in vipDetail.equityList || []"
            :key="index"
          >
            <img
              :src="item.icon"
              class="icon"
            />
            <p class="name">{{item.equityName}}</p>
            <span class="price">{{item.equityDesc}}</span>
          </div>
        </div>
      </div>

    </div>

    <div class="svip-container">
      <!-- svip -->
      <div class="vip-card-container svip" @click="jumpVIP('/vip/svip')">
        <div class="type-item">
          <div class="vip-type">小美VIP·尊享版</div>
          <nd-button class="more-button">更多特权</nd-button>
        </div>
        <p class="exp">每日仅{{svipDetail.dayOfPay}}元，享超{{svipDetail.equityCount}}项权益，最高省{{svipDetail.saveAmt}}元</p>
        <div class="items-contaienr">
          <div
            class="item"
            v-for="(item,index) in svipDetail.equityList || []"
            :key="index"
          >
            <img
              :src="item.icon"
              class="icon"
            />
            <p class="name">{{item.equityName}}</p>
            <span class="price">{{item.equityDesc}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="more-container">
      <div class="shou-xin">
        <img src="./images/icon_tishi@2x.png"/>
        <span>授信/提现通过率视用户综合资质评定，该权益不提升通过率</span>
      </div>
      <div class="title">更多精选权益推荐</div>
      <img :src="oyuan" @click="jumpVIP('/vip/svip')" v-stat="{id: 10264,args: {}}">
      <div class="more-tips ">
        更多福利 敬请期待…
      </div>
    </div>

    <div class="btn-container">
      <div class="radio-container">
        <div :class="['item', {active: checkItem===1}]" @click="check(1)">小美轻享VIP</div>
        <div :class="['item', {active: checkItem===0}]" @click="check(0)">小美尊享VIP</div>
      </div>
      <nd-button
        class="continue-btn"
        @click="openBuyDialog"
        v-stat="{ id: 10268, args: { step: 'pre-vip' } }"
      >
        <span>&nbsp;&nbsp; 
          <template v-if="priceDetail.expireDate">限时{{fixNum(priceDetail.discount*100).replace('0','')}}折起</template>
          <template v-else> 优惠价 </template>
          ¥{{priceDetail.discountPrice}}
        </span>
        <span class="line-through ">原价¥{{priceDetail.price}}</span>
      </nd-button>
      <span class="ui-bubble" v-if="priceDetail.expireDate">
        活动剩余时间 <van-count-down :time="priceDetail.expireDate-new Date().getTime()"  format="DD天HH时mm分" />
      </span> 
      <div class="xy-tips"><span class="text">开通即同意</span><span
        class="xy-active"
        @click="routerToVipProtocol"
      >《小美VIP会员用户协议》</span></div>
    </div>
    <!-- 弹窗/返回挽留 -->
    <nd-dialog
      v-model="dialog.detention"
      :footer="false"
      closeBtn
      class="activity-dialog cat"
    >
      <div class="activity-template-content ">
        <div class="title">放弃小美VIP会员</div>
        <div class="content">
          <p>
            现在成为会员，享超100项专属特权；
            吃喝玩乐出行样样省心；
            提现享超值福利！
          </p>
        </div>
        <div class="button-group">
          <nd-button
            class="btn"
            @click="openBuyDialog()"
          >立即领取</nd-button>
          <div
            class="giveup-btn"
            @click='back'
          >不想省钱了 </div>
        </div>
      </div>
    </nd-dialog>

    <!-- 购买会员类型选择 -->
    <nd-dialog
      v-model="dialog.buy"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-template-content">
        <div class="title">小美VIP{{checkItem===1?'轻享':'尊享'}}版会员</div>
        <div class="content">
          <p>现在开卡即可尊享会员特权，畅享专属金融权益与超爽生活福利！</p>
        </div>
        <div class="vips">
          <div
            @click="active=item.memberGoodsCd"
            :class="['item', {active: item.memberGoodsCd === active }]"
            v-for="(item,index) in vipList"
            :key="index"
          >
            <img
              :src="iconVip"
              class="vipIcon"
            >
            <p>
              {{vipType[item.memberGoodsCd]}} ￥{{item.discountPrice}}<br>
              <span class="line-through yj">原价￥{{item.price}}</span>
            </p>
          </div>
        </div>
        <div class="button-group">
          <nd-button
            class="btn"
            @click="buy()"
          >立即购买 </nd-button>
          <div class="xy-tips">开通即同意 <span
            class="active"
            @click="routerToVipProtocol"
          >《小美VIP会员协议》</span> </div>

        </div>
      </div>
    </nd-dialog>
    <!-- 弹窗/有会员状态在支付中 -->
    <nd-dialog
      v-model="dialog1"
      :footer="false"
      closeBtn
      class="activity-dialog "
    >
      <div class="activity-template-content ">
        <div class="title">温馨提示</div>
        <div class="content">
          <p>您有一笔未完成的{{vipType[payStatusInfo.goodsCd]}}{{['SC_HY','SC1_HY'].includes(payStatusInfo.memberType)?'SVIP':'VIP'}}支付交易</p>
        </div>
        <div class="button-group">
          <nd-button
            class="btn"
            @click="jump(payStatusInfo.goodsCd,'continue')"
          >继续支付</nd-button>
          <div
            class="giveup-btn"
            @click='giveup'
          >放弃支付 </div>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Base64 } from 'js-base64'
import { getKey, judgeClientSystem } from '../../assets/utils'
import { generateUUID } from '../../services/stat'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import oyuan from './images/img_oyuan.png'
import iconVip from './images/icon_vip.png'
import qs from 'qs'

const deviceInfo = {
  terminal: getKey('terminal') || 'H5',
  appVersion: getKey('appVersion'),
  uuid: generateUUID()
}
export default {
  name: 'preVip',
  data () {
    return {
      oyuan,
      iconVip,
      isVip: false,
      detail: {},
      vipInfomation: {},
      vipDetail: {},
      svipDetail: {}, 
      active: this.$route.query.supportMemberGoodsCd || 'EC_M',
      dialog: {
        detention: false,
        buy: false
      },
      vipActive: {
        BC_M: '0',
        BC_HY: '1',
        BC_Y: '2',
        LC_M: '0',
        LC_HY: '1',
        LC_Y: '2',
        EC_M: '0',
        EC_HY: '1',
        EC_Y: '2'
      },
      payStatusInfo: {},
      dialog1: false,
      checkItem: this.$route.query.memberGoodsGroupCd === 'LIGHT_ENJOY' ? 1 : 0,
      goodDetail: {},
      vipInfo: {},
      svipInfo: {},
      groupInfos: {},
      vipType: {
        BC_HY: '半年卡',
        BC_M: '月卡',
        BC_Y: '年卡',
        EC_HY: '半年卡',
        EC_M: '月卡',
        EC_Y: '年卡',
        LC_HY: '半年卡',
        LC_M: '月卡',
        LC_Y: '年卡'
      },
      source: '',
      showPoint: !!localStorage.getItem('preRule')
    }
  },
  components: {
    notice: () => import('./components/notice')
  },
  computed: {
    priceDetail () {
      return this.checkItem === 1 ? this.vipDetail : this.svipDetail
    },
    vipList () {
      return this.checkItem === 1 ? this.vipInfo : this.svipInfo
    }
  },
  watch: {
    'dialog.detention' (val) {
      this.$report({
        id: 10240,
        args: { visible: Number(val) }
      })
    },
    checkItem (val) {
      if (val === 0) {
        this.active = 'EC_M'
      } else {
        this.active = 'LC_M'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path.includes('vip/index') || from.path.includes('withdraw') || from.path.includes('authentication')) {
      next(vm => {
        vm.source = 'ndmicro'
      })
    } else {
      next()
    }
  },
  async mounted () {
    await this.init()
    this.$report({
      id: 10002,
      args: {
        screen: 'page_pre_vip',
        target: this.isVip ? 'vip' : 'novip'
      }
    })
    this.getGoodsInfo('ENJOY') // 小美VIP尊享版
    this.getGoodsInfo('LIGHT_ENJOY') // 小美VIP轻享版
    this.getGroupInfo()
    this.getPpopInfo()
  },
     
  methods: {
    ...mapActions('vip', [
      'memberInfo',
      'groupInfo',
      'popInfo',
      'goodsInfo',
      'orderList',
      'orderCancel'
    ]),
    jumpRule () {
      if (!localStorage.getItem('preRule')) {
        localStorage.setItem('preRule', 'T')
      }
      this.$router.push('/vip/rule')
    },
    jumpVIP (path) {
      const origin = process.env.VUE_APP_PAYURL
      const token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      const { type } = this.$route.query || {}
      const url = `${origin}${path}?${qs.stringify({ type, token, channel })}`
      window.location.href = url
      // this.$router.push({ path, query: { type } })
    },
    async getPpopInfo () {
      const res = await this.popInfo({
        memberGoodsGroupCd: 'ENJOY'
      })
      if (res.success) {
        this.vipInfomation = res.data || {}
      }
    },
    async buy () {
      const res = await this.orderList({ Status: '' })
      if (res.success) {
        this.payStatusInfo = res.data || {}
        if (
          this.payStatusInfo &&
          this.payStatusInfo.payStatus &&
          this.payStatusInfo.payStatus === 'WAIT_PAY'
        ) {
          this.dialog.buy = false
          this.dialog1 = true
        } else {
          this.jump()
        }
      }
    },
    async giveup () {
      const res = await this.orderCancel({
        orderNo: this.payStatusInfo.exPaySerialNo
      })
      if (res.success) {
        this.init()
        this.dialog1 = false
      }
    },
    jump (type, modeOfPayment) {
      let discountPriceValue = ''
      let mode = {}
      if (modeOfPayment === 'continue') {
        const { originalAmount, couponUseDetail, reducedAmount } = this.payStatusInfo || {}
        discountPriceValue = originalAmount
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      this.$report({
        id: 10265
      })
      let { couponRecordId } = this.$route.query || ''
      const _item = this.vipList.find(item => item.memberGoodsCd === this.active)
      const memberGoodsGroupCd = this.checkItem === 1 ? 'LIGHT_ENJOY' : 'ENJOY'
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = Base64.encode(
        JSON.stringify(
          Object.assign({}, deviceInfo, {
            longitude: getKey('longitude') || '',
            latitude: getKey('latitude') || ''
          })
        )
      )
      const origin = process.env.VUE_APP_PAYURL
      const path = '/pay'
      const channel = getKey('channel') || ''
      const query = { 
        memberType: type || this.active, 
        memberGoodsGroupCd: type ? this.payStatusInfo.memberGoodsGroupCd : memberGoodsGroupCd, 
        discountPrice: discountPriceValue || _item.discountPrice,
        couponRecordId,
        host,
        gid,
        token,
        channel,
        device,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}`
      // this.$router.push(
      //   { path: '/vip/middle',
      //     query: { 
      //       memberType: type || this.active, 
      //       memberGoodsGroupCd: type ? this.payStatusInfo.memberGoodsGroupCd : memberGoodsGroupCd, 
      //       discountPrice: discountPriceValue || _item.discountPrice,
      //       couponRecordId,
      //       host,
      //       gid,
      //       token,
      //       device,
      //       ...mode
      //     } 
      //   }
      // )
    },
    openBuyDialog (type) {
      this.dialog.buy = true
    },
    fixNum (value) {
      return value
        ? Number(value)
          .toFixed(2)
          .replace(/(\.?0*$|$)/, '')
        : ''
    },
    check (item) {
      this.$report({
        id: 10163,
        args: {
          position: item
        }
      })
      this.checkItem = item
    },
    async init () {
      const res = await this.memberInfo()
      this.$bus.$emit('ready')
      if (res.success && res.data) {
        this.isVip = res.data && !!res.data.memberNo
        const { memberStatus } = res.data || {}
        if (memberStatus === 'NORMAL') {
          this.$router.replace('/vip/index')
        }
      }
    },
    async getGoodsInfo (type) {
      const res = await this.goodsInfo({
        memberGoodsGroupCd: type,
        productCode: 'TMD'
      })
      this.$bus.$emit('ready')
      if (res.success && res.data) {
        if (type === 'ENJOY') {
          this.svipInfo = res.data
        } else {
          this.vipInfo = res.data
        }
      }
    },
    async getGroupInfo () {
      const res = await this.groupInfo({
        productCode: 'TMD'
      })
      this.$bus.$emit('ready')
      if (res.success && res.data) {
        const _showDetail = res.data || []
        this.vipDetail = _showDetail[1] || {}
        this.svipDetail = _showDetail[0] || {}
      }
    },
    // 用户挽留政策
    detention () {
      if (this.detail.memberStatus !== 'NORMAL') {
        this.dialog.detention = true
      } else {
        this.back()
      }
    },
    back () {
      const { type } = this.$route.query || {}
      this.$report({
        id: 10243,
        args: { target: 2 }
      })
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        return jsBridge('exit')
      } else {
        if (type === 'center') {
          window.location.replace(`${process.env.VUE_APP_PAYURL}/vip/ssvip/pre?type=ssvip`)
        } else if (this.source === 'ndmicro') {
          this.$router.go(-1)
        } else {
          this.$router.push('/mine')
        }
      }
    },
    routerToVipProtocol () {
      this.$report({
        id: 10019,
        args: { position: 1 }
      })
      this.dialog.welfare = false
      this.dialog.vipPast = false
      this.$router.push('/protocol/vip')
    }
  }
}
</script>

<style lang="less" scope>
@import "../../assets/less/mixin.less";

.pvip-container {
  .line-through {
    text-decoration: line-through;
    &.yj {
      font-size: 20px;
    }
  }
  .activity-dialog {
  border-radius: 30px;
  &.cat .default-content {
    &::after {
      content: "";
      position: absolute;
      width: 178px;
      height: 154px;
      background: url("./images/img_mao02.png") no-repeat;
      background-size: contain;
      top: -152px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .default-content {
    background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%) !important;
    .activity-template-content {
      width: 620px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px;

      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #763e12;
        line-height: 45px;
        text-align: center;
      }
      .content {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763e12;
        line-height: 37px;
        padding: 20px 0;
      }
      .btn {
        width: 440px;
        height: 74px;
        line-height: 74px;
        margin-top: 30px;
        background: linear-gradient(270deg, #d79663 0%, #e4b378 100%);
      }
      .giveup-btn {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763e12;
        line-height: 40px;
        text-align: center;
        margin-top: 30px;
      }
      .xy-tips {
        color: #763e12;
        text-align: center;
        margin-top: 30px;
        .active {
          color: #763e12;
          text-decoration: underline;
        }
      }
      .vips {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 20px 0;
        .vipIcon {
          width: 64px;
          height: 24px;
        }
        .item {
          width: 154px;
          height: 200px;
          background: #fffceb;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          text-align: center;
          padding: 20px 0;
          border: 1px solid #fbbf7c;
          position: relative;
          &:after {
            content: "";
            position: absolute;
            right: -18px;
            bottom: -18px;
            width: 36px;
            height: 36px;
            background: url("./images/circle_b.png") no-repeat;
            background-size: 100% 100%;
          }
          p {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763e12;
            line-height: 33px;
          }
          &.active {
            background: #fff2cb;
            border: 3px solid #fbbf7c;
            &:after {
              background-image: url("./images/circle_a.png");
            }
          }
        }
      }
      .step {
        p {
          padding-bottom: 30px;
          i {
            background: #763e12;
            font-style: normal;
            width: 40px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            text-align: center;
            border-radius: 100%;
            color: #fffceb;
            position: relative;
            &.line::after {
              content: "";
              position: absolute;
              width: 2px;
              height: 20px;
              background: #d79663;
              font-size: 0;
              left: 50%;
              top: 45px;
            }
          }
        }
      }
    }
  }
}
  .nd-navigation .center {
    flex: 1;
    text-align: right;
  }
  .section-vip {
    background: #1c2032;
    overflow: hidden;
    .notice {
      margin-bottom: 20px;
    }
  }
  .vip-card-container {
    width: 670px;
    height: 350px;
    background: linear-gradient(270deg, #d5dfee 0%, #eaf1ff 100%);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin: 0 auto;
    padding: 30px;
    display: flex;
    flex-direction: column;
    font-weight: 500;
    color: #3f495f;
    .type-item {
      display: flex;
      height: 50px;
      font-size: 36px;
      line-height: 50px;
      display: flex;
      justify-content: space-between;
      margin-top:10px;
    }
    .vip-type {
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .more-button {
      width: 140px;
      height: 44px;
      line-height: 44px;
      font-size: 24px;
      color: #763e12;
      display: block;
      padding: 0;
      background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%);
      border-radius: 24px;
    }
    .exp {
      font-size: 22px;
      padding-bottom: 20px;
    }
    .items-contaienr {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      .icon {
        width: 40px;
        height: 40px;
      }
      .name {
        font-size: 18px;
        font-weight: 400;
        margin-top: 10px;
      }
      .price {
        height: 33px;
        font-size: 18px;
        line-height: 33px;
        margin-top: 20px;
      }
    }
    &.svip {
      color: #fff;
      background: #fff;
      background: linear-gradient(270deg, #43476b 0%, #5d5a81 100%);
    }
  }

  .more-tips {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    text-align: center;
    margin-top: 30px;
  }
  .shou-xin{
    display: flex;
    align-items: center;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-bottom:22px;
    >img{
      width: 24px !important;
      height: 26px;
      margin:0 8px 0 0  !important;
    }
  }
  .more-container {
    height: 858px;
    background: #f7f7f7;
    position: relative;
    padding: 75px 40px 0;
    ::before {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      content: "";
      width: 0;
      height: 0;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
      border-top: 14px solid #4e4f74;
    }
    .title {
      height: 75px;
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #763e12;
      line-height: 75px;
    }
    img {
      width: 670px;
      margin-top: 20px;
    }
  }

  .svip-container {
    position: relative;
    padding-top: 75px;
    ::before {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      content: "";
      width: 0;
      height: 0;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
      border-top: 14px solid #e1e9f7;
    }
  }
  .rule-txt {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0 20px;
  }
  .point::before{
    content:'';
    display: inline-block;
    width: 16px;
    height: 16px;
    background: #B31B1A;
    border-radius:50%;
  }
  .btn-container {
    padding: 30px;
    width: 750px;
    height: 330px;
    background: #ffffff;
    box-shadow: 0px -10px 20px 0px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
    .nd-button {
      background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%);
      color: #763e12;
    }
    .ui-bubble {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffd8bc;
      line-height: 33px;
      top: 110px;
      right: 40px;
      position: absolute;
      background: linear-gradient(90deg, #ff5f34 0%, #ff3333 100%);
      border-radius: 100px;
      padding: 5px 20px;
      border-bottom-left-radius: 0;
      display: flex;
      .van-count-down{
        font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffd8bc;
      line-height: 33px;  
      }

      &:after {
        display: none;
        border-top: 10px solid #000;
        border-right: 22px solid transparent;
      }
    }
    .text {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .xy-active {
      color: #8eb2d8;
    }
    .line-through {
      font-size: 24px;
      margin-left: 20px;
    }
  }

  .radio-container {
    display: flex;
    justify-content: space-between;
    width: 645px;
    .item {
      width: 310px;
      height: 78px;
      border-radius: 12px;
      border: 2px solid #763e12;
      font-size: 28px;
      color: #763e12;
      line-height: 78px;
      text-align: center;
      &.active {
        background: url('./images/check.png') no-repeat right bottom;
        background-size: 47px 47px;
      }
    }
  }
}
</style>